import OpenOtherApi from '@/api/OpenOtherApi';
import store from '@/store';
import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';

interface OemState {
  config: any
}

@Module({ name: 'oem', dynamic: true, namespaced: true, store })
class OemInfo extends VuexModule implements OemState {
  config = {} as any

  @Mutation
  private SET_OEM_CONFIG (config) {
    this.config = config
  }

  @Action
  public setOemConfig (config) {
    this.SET_OEM_CONFIG(config)
  }

  @Action({ rawError: true })
  public init () {
    OpenOtherApi.getOemConfig().then(res => {
      this.setOemConfig(res)
    })
  }
}

export const OemModule = getModule(OemInfo)
